import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import VcsAgentPoolActions from "../../components/VcsAgentPoolActions";
import { VcsAgentPoolView } from "../../types";

const VCSAgentPoolsTableDropdownCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<VcsAgentPoolView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <VcsAgentPoolActions vcsAgentPool={item} dotsSize="small" />
    </TableSimpleCell>
  );
};

export default VCSAgentPoolsTableDropdownCell;
